let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eF8g9")).then(() => parcelRequire('cW9vr'));